module.exports = __webpack_public_path__ + "static/media/Registry_More_Gifts@2x.6c355221.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/registry/Registry_More_Gifts@2x.jpg
// module id = 1268
// module chunks = 53